import { fetchWithCache, getCachedData } from "../services/apiService";

export const userLenderSearch = async (
  legal_first_name,
  legal_last_name,
  { setResults },
) => {
  const cacheKey = `/api/user/lenderSearch_${legal_first_name}_${legal_last_name}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached) {
    setResults(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/user/lenderSearch",
      {
        method: "POST",
        body: JSON.stringify({
          legal_first_name,
          legal_last_name,
        }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    setResults(data);
  } catch (error) {
    if (!cached) {
      setResults([]);
    }
  }
};
